<template>
    <div>
        <div style="font-size: 60px;">Booking Status is loading...</div>

            <!-- <div  v-if="!sCreateBookingRes" style="font-size: 60px;">
         Booking Status is loading...

        </div>
         <CCard>
         
             <CCardBody
             v-if="sCreateBookingRes">
                 <p v-for="(bookingDetail,index) in sCreateBookingRes.data.data.bookingStatus.BookingDetails" :key="index">pnr
              {{bookingDetail.pnr}} ||{{bookingDetail.ticketingDeadline}}
                 </p>
           
                    </CCardBody> -->

      <!-- <cAlertModal
      :show="isAlert"
      :status="0"
      :buttonList="getBookFailModalBtns()"
      :desc="alertValue"
    ></cAlertModal> -->
            <!-- </CCard> -->
    </div>
</template>
<script>
import { cloneData ,addClassToBody,removeClassBody } from "../../../../util/util";
import {mapGetters, mapActions} from "vuex";
import Vue from 'vue';
import { COMPONENT_NAME, PATHNAME,ROUTER_PARAM, PAYMENT_PROCEED_TO, PROCEED_TO_TYPE, BOOKING_PAYMENT_STATUS, BOOKING_PAYMENT_ERRORS} from "../../../../util/constants";
import router, { navigate, goBack } from "../../../../router/index";
import apiGetOrderDetails from "../../../../services/apiGetOrderDetails.js";
import cAlertModal from "../../../../components/form/cAlertModal";
import Logger from "../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import BaseConfiguration from "../../../../config/base";
import {handleJWT,getErrorAlertValue, handleSessionExist,} from "../../../../util/util";
export const bus = new Vue();
export default {
    name:COMPONENT_NAME.BOOKING_STATUS_PAGE,
    data() {
    return {
     token:null,
     alertValue:null,
     isAlert:false
    }},
    components: {
    cAlertModal,
    
  },
  
     computed: { 
         ...mapGetters("sPaymentPage", {
             sCreateBookingRes: "GET_CREATE_BOOKING_RES",
           sCreateBookingReq: "GET_CREATE_BOOKING_REQ"
            }),
            
        },
    methods:{
      
      ...mapActions("sPaymentPage", {
      SET_ORDER_DETAIL_RES:"SET_ORDER_DETAIL_RES",
      
    }),

          async getOrderDetails(pToken) {
              let retValue;
              try {
                if(BaseConfiguration.isDebug) console.log("getOrderDetails");
                let orderDetReq = apiGetOrderDetails.buildRequest(pToken);

                if(orderDetReq){
                    let orderRes = await apiGetOrderDetails.getResponse(orderDetReq);

                     if (VALIDATE_SUCCESS_RES(orderRes)) {
                        retValue = orderRes.data;
                        retValue['token']=this.token;
                        this.SET_ORDER_DETAIL_RES(retValue);
                        if(retValue.data.proceedTo) {
                        this.navByProceedTo(retValue.data);
                        }
                        
                     }
                     else {
                        //if status error
                        retValue = orderRes.data;
                        
                        let error = getErrorMessage(orderRes);
          
                        let isJwt = handleJWT(error);
                        if (!isJwt) {
                            let isSessionExpired;
                            if(orderRes){
                              isSessionExpired = handleSessionExist(orderRes.data);
                            }
                         if(!isSessionExpired){
                            // this.alertValue=getErrorAlertValue(error);
                        this.SET_ORDER_DETAIL_RES(retValue);
                        if(retValue.data.proceedTo) {
                        this.navByProceedTo(retValue.data);
                        }else{
                          navigate(PATHNAME.FAILEDPAGE);
                          throw 'Undefined proceed to from createBooking api response';
                        }
                       
                        }
                     }
                  }

                }
          
              } catch (err) {
                      let body = Logger.buildRequest(
                        COMPONENT_NAME.BOOKING_STATUS_PAGE,
                        "error in getOrderDetails",
                        err.toString(),
                        "getOrderDetails",
                        LOG_TYPE.ERROR
                      );
                      Logger.getResponse(body);
                    }
                return retValue;
              }, 

    checkForSessId(porderDetRes){
      try{
        if(porderDetRes && porderDetRes.sessionId) {
          
                 param[ROUTER_PARAM.SESSION_ID] = porderDetRes.sessionId;
                 navigate(PATHNAME.PAYMENTPAGE, param);
      
        }
        else{
          navigate(PATHNAME.FLIGHTSEARCH)
        }
      } catch (err) {
                      let body = Logger.buildRequest(
                        COMPONENT_NAME.BOOKING_STATUS_PAGE,
                        "error in checkForSessId",
                        err.toString(),
                        "checkForSessId",
                        LOG_TYPE.ERROR
                      );
                      Logger.getResponse(body);
                    }
    },

    ///navigate to corresponding pages using proceedTo from booking response
    navByProceedTo(porderDetRes) {
      
      try {
        if (BaseConfiguration.isDebug) console.log("navByProceedTo");
        let param = {};
        switch (porderDetRes.proceedTo) {
         
          case PAYMENT_PROCEED_TO.ERROR_PAGE:
            {
              
              if(porderDetRes && porderDetRes.sessionId && porderDetRes.sessionId!="*") {
                 param[ROUTER_PARAM.SESSION_ID] = porderDetRes.sessionId;
                  navigate(PATHNAME.FAILEDPAGE,param);
              }else if(porderDetRes && porderDetRes.sessionId) {
                 navigate(PATHNAME.FAILEDPAGE);
              }else if(porderDetRes ) {
                navigate(PATHNAME.FAILEDPAGE);
               
              }
             
            }
            break;
          case PAYMENT_PROCEED_TO.PAYMENT_PAGE:
            {
             if(this.sCreateBookingReq){
             if(this.sCreateBookingReq.hasOwnProperty('sessionId')){
                if(porderDetRes && porderDetRes.sessionId && porderDetRes.sessionId!="*") {
                 param[ROUTER_PARAM.SESSION_ID] = porderDetRes.sessionId;
                 navigate(PATHNAME.PAYMENTPAGE, param);
              }else{
                this.checkForSessId(porderDetRes);
                //  throw "invalid sessioId for navigation :" +PATHNAME.PAYMENTPAGE+' by proceedTo:' + porderDetRes.proceedTo;
              }
             }else{
                navigate(PATHNAME.TICKET_NOW);
             }
             }else{
               this.checkForSessId(porderDetRes);
                // throw "invalid navigation for proceedTo:" +porderDetRes.proceedTo;

             }
            
              // if(porderDetRes && porderDetRes.sessionId && porderDetRes.sessionId!="*") {
              //    param[ROUTER_PARAM.SESSION_ID] = porderDetRes.sessionId;
              //    navigate(PATHNAME.PAYMENTPAGE, param);
              // }else if(porderDetRes && porderDetRes.sessionId ) {
              //   navigate(PATHNAME.TICKET_NOW);
              // }
               
            }
            break;
          
          case PAYMENT_PROCEED_TO.SUCCESS_PAGE:
            {
              if(porderDetRes && porderDetRes.sessionId && porderDetRes.sessionId!="*" ) {
                 param[ROUTER_PARAM.SESSION_ID] = porderDetRes.sessionId;
                 navigate(PATHNAME.SUCCESSPAGE, param);
              }else if(porderDetRes && porderDetRes.sessionId) {
                navigate(PATHNAME.SUCCESSPAGE);
              }
             
            }
            break;
          
          case PAYMENT_PROCEED_TO.PENDING_PAGE:
            {
              if(porderDetRes && porderDetRes.sessionId && porderDetRes.sessionId!="*") {
                 param[ROUTER_PARAM.SESSION_ID] = porderDetRes.sessionId;
                 navigate(PATHNAME.PENDINGPAGE, param);
              }else if(porderDetRes && porderDetRes.sessionId) {
                navigate(PATHNAME.PENDINGPAGE);
              }
              
            }
            break;

          default:
            
                          navigate(PATHNAME.FAILEDPAGE);
                          throw "unhandled proceedTo : " +porderDetRes.proceedTo;
            
            break;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.BOOKING_STATUS_PAGE,
          "error in navByProceedTo",
          err.toString(),
          "navByProceedTo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///logger status,error,sessId,orderId,orderPaymentId,authToken if there is no token in query string
  loggerFunc() {
    
      try {
        if(BaseConfiguration.isDebug) console.log("loggerFunc");
        let status = this.$router.currentRoute.query[ROUTER_PARAM.STATUS];
        let error = this.$router.currentRoute.query[ROUTER_PARAM.ERROR];
        let sessionId = this.$router.currentRoute.query[ROUTER_PARAM.SESSION_ID];
        let providerId = this.$router.currentRoute.query[ROUTER_PARAM.PROVIDER_ID];
        let orderPaymentId = this.$router.currentRoute.query[ROUTER_PARAM.ORDER_PAYMENT_ID];
        let authToken = this.$router.currentRoute.query[ROUTER_PARAM.AUTHTOKEN];
        
        for (var index in BOOKING_PAYMENT_ERRORS.ERRORS) {
          if(BOOKING_PAYMENT_ERRORS.ERRORS[index]==error) {
            error=index;
          }
          
        }
         let body= { 
           status : status,
          error : error,
          sessionId : sessionId,
         providerId : providerId,
         orderPaymentId : orderPaymentId,
         authToken : authToken,
         }
         

        navigate(PATHNAME.FAILEDPAGE);
        throw body;
          

      } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.BOOKING_STATUS_PAGE,
                  "no token has received",
                  JSON.stringify(err),
                  "loggerFunc",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
      
  }, 

    

},

    mounted() {
     
        this.$root.$emit("toggle-sidebar-minimize");
    },
    async created(){
        try {
          if(BaseConfiguration.isDebug) console.log("created");
          this.$root.$emit("toggle-sidebar-minimize"); 
          // console.error(this.$router.currentRoute.query);
       this.token = this.$router.currentRoute.query?this.$router.currentRoute.query[
            ROUTER_PARAM.TOKEN
          ]:null;
      
          if(this.token){
        let orderDetailRes = await this.getOrderDetails(this.token);
      

      

        // if(orderDetailRes&&orderDetailRes.data &&
        // orderDetailRes.data.proceedTo ==PAYMENT_PROCEED_TO.SUCCESS_PAGE && 
        // (orderDetailRes.data.ticketNumbers==null||orderDetailRes.data.ticketNumbers.length==0 ))
        // {
        //    let that=this;
            
        //      let intervalTime = setInterval( async function(){
                
        //         orderDetailRes = await that.getOrderDetails(that.token)
        //         if(orderDetailRes && orderDetailRes.data && orderDetailRes.data.ticketNumbers
        //          && orderDetailRes.data.ticketNumbers.length)
        //               {
                       
        //               clearInterval(intervalTime);
        //               that.emitFunction(orderDetailRes.data.ticketNumbers);
        //               }   
                
        //      },20000)
              
        // }
      
          }
          /// if there is no token
          else{
            this.loggerFunc();  
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.BOOKING_STATUS_PAGE,
                  "error in created",
                  err.toString(),
                  "created",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
   }, 

     beforeCreate() {    
   addClassToBody(COMPONENT_NAME.BOOKING_STATUS_PAGE);
  },
  
   beforeDestroy() {
              this.$root.$emit("toggle-sidebar-minimize", true);

       removeClassBody();
    },
}
</script>